export const isProduction =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ||
  process.env.VERCEL_ENV === "production";

export const isPreview = () =>
  process.env.VERCEL_ENV === "preview" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";

export const isStaging = () => process.env.VERCEL_GIT_COMMIT_REF === "staging";
